import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {ShowerComboTubType} from "../../constants";

export default class ShowerWall extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_interior_wall';
    this.partName = 'Shower Walls';
    this.translateId = "visualizer.bathroom.shower.shower_interior_wall";
    this.homePageTitle = 'Interior Shower Walls';
    this.dbName = "Shower Wall";
    this.isStoneFeature = true;
    this.canUseWizard = true;
    this.layerPriority = 2;
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Shower"]) {
      dbFeature.metaData["Shower"] = ["Shower"];
    }
    return super.load_(dbFeature, new ShowerWall());
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    super.handleClick(ignoreLocked);
    const shower = parent.getParent();
    if (shower.showerInteriorWallAccent && shower.showerInteriorWallAccent.canBeDisabled
      && !shower.showerInteriorWallAccent.placeholderChanged && !getFeatureIsLocked(this)) {
      shower.showerInteriorWallAccent.disabled = true;
      shower.showerInteriorWallAccent.disabledClick();
    }
    this.featureClicked();
  }

  availableFeatures(wallFeatures) {
    return wallFeatures.filter(wallFeature => wallFeature.partNumber === 1)
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    const showerCondition = showerParent.showerTubComboIsActive() && showerParent.layout.parts[ShowerTubCombo.id]
    && (showerParent.layout.parts[ShowerTubCombo.id].bottomTub === ShowerComboTubType.walk_in_tub)
      ? "Tub"
      : "Shower";
    conditions.push({
      propName: "Shower",
      propValue: showerCondition
    });
    return conditions
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Background.ShowerWall;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
  }
}
